import { render, staticRenderFns } from "./MemoruSales.vue?vue&type=template&id=24eb45b8&"
import script from "./MemoruSales.vue?vue&type=script&lang=ts&"
export * from "./MemoruSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports